<!-- Carries the minTableWidth input down to both tables as a custom property: a media query can
override that, an inline width on the table itself could not. -->
<div class="table-frame" [style.--lib-virtual-scroll-table-min-width]="minTableWidth">
  <!-- Fixed header table. It sits outside the scrolling viewport, so in horizontalScroll mode its own
  overflow is hidden and its scrollLeft is driven from the viewport instead - that keeps the
  columns lined up while the only visible bars stay on the viewport, where they are in view. -->
  <div class="header-scroll" #headerScroll>
    <table #headerTable [ngClass]="rowType" class="header-table">
      <thead>
        <ng-container *ngTemplateOutlet="headers || defaultHeaderTemplate; context: { $implicit: data }"></ng-container>
      </thead>
    </table>
  </div>

  <!-- Virtual-scrolled body -->
  <cdk-virtual-scroll-viewport
    [itemSize]="itemSize"
    class="virtual-scroll-viewport"
    (scrolledIndexChange)="onScrollIndexChange()"
  >
    <table #bodyTable [ngClass]="rowType" class="body-table">
      <tbody [ngClass]="{ 'with-action': withAction }">
        <ng-container *cdkVirtualFor="let item of data; trackBy: trackBy || defaultTrackBy">
          <ng-container *ngTemplateOutlet="rows || defaultRowTemplate; context: { $implicit: item }"></ng-container>
        </ng-container>
      </tbody>
    </table>
  </cdk-virtual-scroll-viewport>
</div>

<ng-template #defaultHeaderTemplate let-data>
  <tr>
    @for (header of data[0] | keyvalue; track header) {
      <th>{{ header.key }}</th>
    }
  </tr>
</ng-template>
<ng-template #defaultRowTemplate let-row>
  <tr>
    @for (cell of row | keyvalue; track cell) {
      <td>{{ cell.value }}</td>
    }
  </tr>
</ng-template>
